import {	defineStore} from "pinia";
import piniaPersistConfig from "@/config/piniaPersist";

const id = "MenuState";

/**
 * 選單相關store
 */
export const MenuStore = defineStore({
	id: id,
	state: () => ({
		collapsed: false,
		overlay: false
	}),
	getters: {
		isCollapsed: state => {
			return state.collapsed
		},
		isOverlay: state => {
			return state.overlay
		}
	},
	actions: {
		setCollapsed(collapsed) {
			this.collapsed = collapsed;
		},
		setOverlay(overlay) {
			this.overlay = overlay;
		}
	},
	persist: piniaPersistConfig(id)
});
